import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import { getStatusStyle } from '../constants/orderStatus';

/**
 * Header component for the Semen Checkout page.
 * Displays reference number, stallion name, and status badges.
 */
export default function SemenCheckoutHeader({ orderDetails, semenDetails, isAdditionalDose }) {
    const { translate } = useTranslate();

    return (
        <div className="d-flex align-items-center mb-main w-100">
            <h2 className="bold rtl capatalise d-flex align-items-center flex-wrap mb-0">
                {orderDetails?.referenceNumber ? orderDetails?.referenceNumber + ' - ' : ''} 
                {(semenDetails?.regNr && semenDetails.regNr + ' - ')}
                {semenDetails?.horseName || translate('web.semenCheckout', 'Semen Checkout')}

                {isAdditionalDose && (
                    <span
                        className="ms-3"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            background: 'linear-gradient(270deg, #6366f1 0%, #a855f7 100%)',
                            color: '#fff',
                            padding: '4px 12px',
                            borderRadius: '50px',
                            fontSize: '13px',
                            fontWeight: 'bold',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <i
                            className="fa-solid fa-circle-plus"
                            style={{ marginRight: '6px', fontSize: '16px' }}
                        ></i>
                        {translate('web.extraDose', 'ExtraDose')}
                    </span>
                )}

                {orderDetails?.status && !isAdditionalDose && (
                    <span
                        className="ms-3 px-3 py-1 rounded-pill d-inline-flex align-items-center"
                        style={{
                            fontSize: '12px',
                            fontWeight: '700',
                            backgroundColor: getStatusStyle(orderDetails.status).bgColor,
                            color: getStatusStyle(orderDetails.status).color,
                            border: `1px solid ${getStatusStyle(orderDetails.status).color}33`,
                            boxShadow: `0 2px 4px 0 ${getStatusStyle(orderDetails.status).color}15`,
                            textTransform: 'uppercase',
                            letterSpacing: '0.8px'
                        }}
                    >
                        <span style={{
                            width: '7px',
                            height: '7px',
                            borderRadius: '50%',
                            backgroundColor: getStatusStyle(orderDetails.status).color,
                            marginInlineEnd: '8px'
                        }}></span>
                        {orderDetails.statusName}
                    </span>
                )}
            </h2>
        </div>
    );
}
